<template>
  <div>
    <template v-if="readOnly">
      <div v-if="viewItem() !== null && viewItem() !== undefined" :class="{ 'right-align': valueIsNumber && singleLine, 'single-line': singleLine }" class="verdi">
        {{ viewItem() }}
      </div>
      <div v-else class="verdi muted">
        (blank)
      </div>
    </template>
    <template v-else>
      <div class="input-container-wrapper">
        <AutoExpandingTextarea v-if="!readOnly" :class="{invalid: hasError}" :clearable="header.isNullable" :model-value="modelValue?.toString()"
                               class="input-container" @cancel="$emit('update:modelValue', props.modelValue)" @change="changed" @submit="changed"/>
      </div>
      <BaseProgressBar v-if="saving" :value="null" class="saving-progress" />
      <span v-if="hasError" style="color: var(--red-700)">Feil ved lagring!!!</span>
      <div v-else style="height: 4px;padding: 0;margin: 0;" />
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useTableStore } from '@/store/storeTable'
import { formatDate } from '@/helpers/DateFormatter'
import AutoExpandingTextarea from '@/components/BaseComponents/AutoExpandingTextarea.vue'
import BaseProgressBar from '@/components/BaseComponents/BaseProgressBar.vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Array, Date, Object],
    default: null
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  singleLine: {
    type: Boolean,
    default: false
  },
  autoSave: {
    type: Boolean,
    default: true
  },
  rowId: { type: [String, Number], default: '' },
  header: { type: Object, required: true }
});


const emit = defineEmits(['update:modelValue'])


const hasError = ref(false)
const saving = ref(false)

// TableStore
const tableStore = useTableStore()

function changed (newValue)
{
  if (newValue === '' || newValue === null) {
    if (props.header.isNullable) {
      emit('update:modelValue', null)
      if (!props.autoSave) return;
      const item = { rowId: props.rowId, databaseObjectId: props.header.databaseObjectId, columnName: props.header.field, oldValue: props.modelValue, newValue: null };
      hasError.value = false
      saving.value = true
      tableStore.saveData(item);
      saving.value = false;
      return;
    } else {
      hasError.value = true;
      return;
    }
  }
  emit('update:modelValue', newValue)
  if (!props.autoSave) return;
  const item = { rowId: props.rowId, databaseObjectId: props.header.databaseObjectId, columnName: props.header.field, oldValue: props.modelValue, newValue };
  hasError.value = false
  saving.value = true
  tableStore.saveData(item);
  saving.value = false;
}


const valueIsNumber = ref(false)

function viewItem ()
{
  if (props.modelValue) {
    const dates = ['datetime', 'datetime2', 'date', 'time']
    const numbers = ['int', 'bigint', 'decimal', 'numeric']

    if (dates.includes(props.header.basicDataType)) {
      return formatDate(props.modelValue)
    }

    if (numbers.includes(props.header.basicDataType)) {
      const num = Number(props.modelValue)
      valueIsNumber.value = true
      return num.toLocaleString('nb-NO')
    }
  }
  return props.modelValue
}
</script>
<style scoped>
.saving-progress {
  height: 4px;
  padding: 0;
  margin: 0;
  color: lightgreen;
}

.right-align {
  text-align: right;
  width: 100%;
}

.verdi {
  /* min-height: 1.2rem; */
  padding: 8px;
  font-style: italic;
}

.verdi.single-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: inherit;
  max-width: inherit;
  font-style: normal;
}

.verdi.muted {
  color: var(--gray-500);
  font-style: italic;
}

.input-container.invalid {
  border-color: var(--red-700);
}

.input-container-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.clear-button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--gray-500);
  font-size: 1.2rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clear-button:hover {
  background-color: var(--gray-200);
  color: var(--gray-700);
}
</style>
